export default __webpack_public_path__ + "src/images/packages/kosi-forest-lodge/b6f850e4e6a29720ebd5989d9162c724-3.jpg";